<template>
	<div>
		<!-- Top tabs -->
		<div class="flex xs-right xs-12 bb1 bc7">
			<div class="cu2 c2 fw7 p4 bb2 bc2">
				{{ $t("advanced_view") }}
			</div>
		</div>

		<!-- Case Explorer -->
		<case-explorer />
	</div>
</template>

<script>
import CaseExplorer from "../CaseExplorer/CaseExplorer.vue"

export default {
	components: { CaseExplorer }
}
</script>
